import { Injectable } from 'framework/di';

import { AppService } from '../app/app.service';
import { PlatformLoader } from '../platform/platform.loader';

@Injectable
export class B2BService {
  constructor(
    private appService: AppService,
    private platformLoader: PlatformLoader
  ) {}

  addB2BRequestParams<P>(params: P): P | (P & B2BRequestParams) {
    const { b2b } = this.appService.TAEAppConfig;
    if (!b2b?.enabled) return params;

    const { current_company_id, current_location_id } = b2b;
    const companyLocationId = `${current_company_id}_${current_location_id}`;
    const { active, rate } = this.platformLoader.platform.currency || {};

    return {
      ...params,
      company_location_id: companyLocationId,
      currency: active,
      currency_rate: rate,
    };
  }
}

export type B2BRequestParams = {
  company_location_id: string;
  currency: string;
  currency_rate: string;
};
